import { ref ,watch} from '@vue/composition-api'
import { ReportService } from '@/app/reports/share/report.service'

import ReportOptions from '@/views/reports/components/options.js'

const { defaultFromdate, defaultTodate } = ReportOptions()
export default function GeofenceReportLogic() {

  const request = ref({
    page: 1,
    length: 25,
    type: 'supportCenter',

    from: defaultFromdate,
    to: defaultTodate,
    devices: [],
    geofences: [],
  })

  const report_data = ref(null)

  const from = ref(0)
  const to = ref(0)
  const total = ref(0)

  const errors = ref({})
  const loading = ref(false)
  const dataTableloading=ref(false)


  const getReport = () => {

    errors.value = {}
    loading.value = true

    ReportService.getReport(request.value)

      .then(res => {
        report_data.value = setRowSummery(res.data.data)
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => loading.value = false)
  }
  function time_convert(time_in_secondes) {


    var hours = time_in_secondes / (60 * 60);
    var minutes = (hours - parseInt(hours)) * 60

    var sconds = (minutes - parseInt(minutes)) * 60

    let arr_time = []
    if (parseInt(hours) > 0) {
      arr_time.push(parseInt(hours) + "h ")
    }
    if (parseInt(minutes) > 0) {
      arr_time.push(parseInt(minutes) + "m ")
    }
    if (parseInt(sconds) > 0) {
      arr_time.push(Math.round(sconds) + "s ")
    }


    return arr_time.join(" ")

  }
  const setRowSummery = (data) => {
    let new_data = [];
    let current_device = "";
    let total_distance = 0;
    let total_time = 0;

    let days_counter = 0;

    for (let i = 0; i < data.length; i++) {
      if (current_device == "") {
        current_device = data[i].device;
      }

      if (current_device == data[i].device) {
        days_counter += 1;
        total_distance += parseFloat(data[i].distance);
        total_time += parseFloat(data[i].time);
        new_data.push({
          id: i + 1,
          owner: data[i].owner,
          contract: data[i].contract,
          device: data[i].device,
          geofence: data[i].geofence,
          time: time_convert(data[i].time),
          distance: data[i].distance,
          enterTime: data[i].enterTime,
          exitTime: data[i].exitTime
        }
        )

        if (data[i + 1] != undefined && data[i + 1].device != current_device) {
          new_data.push({
            id: '#',
            owner: "",
            contract: "",
            device: "",
            geofence: "",

            groupRow: true,
            // time: (total_time/(60*60)).toFixed(2),
            time: time_convert(total_time),
            "distance": total_distance.toFixed(2) + "km",
            enterTime: "",
            exitTime: "",
          })
          total_distance = 0; current_device = ""; days_counter = 0; total_time = 0;

        } else if (i + 1 == data.length) {
          new_data.push(
            {
              id: '#',
              owner: "",
              contract: "",
              device: "",
              geofence: "",

              groupRow: true,
              time: time_convert(total_time),
              "distance": total_distance.toFixed(2) + "km",
              enterTime: "",
              exitTime: "",
            })
        }
      }


    }

    return new_data;
  }


  const getReportForPdf = () => {
    loading.value = true
    return new Promise((r, j) => {
      ReportService.getReport({
        ...Object.assign(request.value, {
          page: 1
        }), length: 50000
      }).then(res => r(res.data.data))
        .finally(() => loading.value = false)
    })
  }
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  
  
  watch([sortBy,isSortDirDesc],()=>{
  
    request.value.sortBy=  isSortDirDesc.value==true? sortBy.value+',desc':sortBy.value+',asc';
    dataTableloading.value = true

    ReportService.getReport(request.value)

      .then(res => {
        report_data.value = setRowSummery(res.data.data)
        from.value = res.data.from
        to.value = res.data.to
        total.value = res.data.total
      })
      .catch(reason => reason.status === 422 ? errors.value = reason.data.errors : {})
      .finally(() => dataTableloading.value = false)
  })
  

  return {
    getReport, getReportForPdf,
    report_data,
    total, from, to,
    request,
    loading,
    errors,
    sortBy,
    isSortDirDesc,
    dataTableloading
  }
}
